module.exports = __webpack_public_path__ + "static/img/avatar.99f6f51b.png";